export const validateEmail = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;

export const validatePassword = new RegExp("(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\"$%\^&\*])(?=.{8,})");

export const validatePostcode = new RegExp("([A-Za-z][A-Ha-hJ-Yj-y]?[0-9][A-Za-z0-9]? ?[0-9][A-Za-z]{2}|[Gg][Ii][Rr] ?0[Aa]{2})");

export const validatePhone = /^[0-9]{5}\s?[0-9]{6}/;

export const validateNINumber = /[A-CEGHJ-PR-TW-Z]{1}[A-CEGHJ-NPR-TW-Z]{1}[0-9]{6}[A-DFM]{0,1}/;

export const validateDate = /^(0[1-9]|[12][0-9]|3[01])[-/.](0[1-9]|1[012])[-/.](19|20)\d\d$/;

// licence validation removed because it was occasionally failing. Validation ultimately applied by licenceLink
//export const validateLicence = /^^[A-Z9]{5}\d{6}[A-Z9]{2}\d[A-Z]{2}$$/